import { createAppSessionEventDefinition } from "../AppSessionEventDefinition.js";

export const DELETE_SCOPE_ITEM = createAppSessionEventDefinition({
  type: "DELETE_SCOPE_ITEM",
  logSafe: {
    name: false,
  },
  create: (payload: { name: string }) => payload,
  apply: (previousState, payload) => {
    const warnings: string[] = [];

    const previousScopeItem = previousState.scopeItems[payload.name];

    if (previousScopeItem != null) {
      delete previousState.scopeItems[payload.name];
    } else {
      // scope item name is not safe to log
      warnings.push("Scope item not found");
    }

    return { warnings };
  },
});
